/* RESPONSIBLE TEAM: team-inbox */
import { inject as service } from '@ember/service';
import { ParentAction } from './action';
import type InboxHotkeys from 'embercom/services/inbox-hotkeys';
import { HotkeyID } from 'embercom/services/inbox-hotkeys/HotkeyID';
import { NamedIcon } from 'embercom/objects/inbox/command-k/icons';
import type IntlService from 'embercom/services/intl';
import type PermissionsModal from 'embercom/services/permissions-modal';

export default class MergeInto extends ParentAction {
  @service declare inboxHotkeys: InboxHotkeys;
  @service declare intl: IntlService;
  @service declare permissionsModal: PermissionsModal;

  constructor(args: any) {
    super(args);
    this.shortcuts = this.inboxHotkeys.hotkeysMap[HotkeyID.MergeInto];
  }

  id = 'merge-into';
  icon = new NamedIcon('merge');
  paneComponent = 'inbox2/command-k/merge-into/pane';

  canActivate(): boolean {
    let hasFeatureFlag = this.session.workspace.isFeatureEnabled(
      'spg-inbox-manage-conversation-merge',
    );

    if (hasFeatureFlag && !this.session.teammate.permissions.canMergeConversations) {
      this.permissionsModal.showModal({
        permissionsLabel: this.intl.t(
          'inbox.conversation-header.merge-conversations-permission-label',
        ),
      });
      return false;
    }

    return true;
  }
}
